module.exports = __webpack_public_path__ + "static/media/sombra-capa-interna.9aaf1799.svg";